import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleForecastDetails = () => {
  const { forecastId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const decodedId = forecastId ? atob(forecastId) : forecastId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['forecast']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['forecast'] + id + '/', { headers });
      showToast('Forecast deleted successfully', 'success');
      navigate('/reporting/forecast/list');
    } catch (error) {
      console.error('Error deleting Forecast:', error);
      showToast('Failed to delete Forecast', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Forecast"
        listPath="/reporting/forecast/list"
        editPath={`/reporting/forecast/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Forecast"
        message="Are you sure you want to delete this forecast?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
        confirmText="Delete"
        cancelText="Cancel"
      />
    </div>
  );
};

export default SingleForecastDetails;
